import { IconInfo as FigmaIconInfo } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconInfo: FC<IconProps> = props => (
  <SvgIcon {...props} component={FigmaIconInfo} />
)

export default IconInfo
